export default function VerticalSeparator() {
  return (
    <div className="border-start border-secondary-subtle mx-2 align-self-stretch flex-shrink-0" />
  )
}
